module.exports = new (require('fragment-cache'))();



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromatch/lib/cache.js
// module id = I3bo
// module chunks = 0